import { render, staticRenderFns } from "./SynchronizationNew.vue?vue&type=template&id=2a9f3958&scoped=true&"
import script from "./SynchronizationNew.vue?vue&type=script&lang=js&"
export * from "./SynchronizationNew.vue?vue&type=script&lang=js&"
import style0 from "./SynchronizationNew.vue?vue&type=style&index=0&id=2a9f3958&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a9f3958",
  null
  
)

export default component.exports